
import React, { useEffect, useState } from 'react';

interface AnimatedNumberProps {
  end: number;
  duration?: number;
  prefix?: string;
}

const AnimatedNumber = ({ end, duration = 500, prefix = "" }: AnimatedNumberProps) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime: number;
    let animationFrame: number;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      
      setCount(Math.floor(end * percentage));

      if (percentage < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [end, duration]);

  return (
    <span>{prefix}{count.toLocaleString()}</span>
  );
};

export default AnimatedNumber;
